module.exports = __webpack_public_path__ + "static/img/n1_9.05c64bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/n1_9.jpg
// module id = 3shZ
// module chunks = 2